// extracted by mini-css-extract-plugin
module.exports = {"stripTransition":"_3Z4oFdkVlZg0BdYemrYteX","stripSwipe":"_3e5UnUl7ei590i5Cjfdfc1"};